var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.has_error?'errorous no-after':''},[_c('h5',{staticClass:"simple-form-label mb-0",class:'text-'+_vm.type},[_vm._v(_vm._s(_vm.label))]),(_vm.has_error)?_c('label',[_vm._v(" "+_vm._s(_vm.error_text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }